import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import {
  dangerColor,
  whiteColor,
} from "../../assets/jss/material-dashboard-pro-react";

const styles = () => ({
  mouseOverInfo: {
    position: "absolute",
    padding: "4px 6px",
    backgroundColor: whiteColor,
    opacity: "0.85",
    fontSize: "12px",
    lineHeight: "1.4",
    minWidth: "200px",
    zIndex: "10000",
    pointerEvents: "none",
    borderRadius: "2px",
    transition: "opacity 0.1s",
    "&.hidden": {
      opacity: "0",
    },
  },
  mouseOverValue: {
    fontWeight: "bold",
    "&.negative": {
      color: dangerColor[0],
    },
  },
});

const useStyles = makeStyles(styles);

const PnlTooltip = ({
  visible,
  mouseMoving,
  x,
  y,
  metaName,
  numPL,
  plValues,
  currencyUnit,
  volumeUnit,
  formatValue,
  getPlPercentValue,
  showValueByVolumeDecimals,
  tooltipRef,
  oomData,
  t,
}) => {
  const classes = useStyles();

  const shouldRender =
    visible &&
    metaName &&
    numPL &&
    plValues[numPL] &&
    plValues[numPL][metaName] !== undefined &&
    currencyUnit &&
    volumeUnit &&
    oomData;

  return (
    <div
      ref={tooltipRef}
      className={cx({
        [classes.mouseOverInfo]: true,
        ["hidden"]: !visible || mouseMoving,
      })}
      style={{
        left: `${x}px`,
        top: `${y}px`,
      }}
    >
      {shouldRender && (
        <>
          <div>
            {t("results.nominal_value")}:{" "}
            <span
              className={cx({
                [classes.mouseOverValue]: true,
                ["negative"]: plValues[numPL][metaName] < 0,
              })}
            >
              {currencyUnit}{" "}
              {formatValue(
                plValues[numPL][metaName],
                metaName,
                numPL,
                "value",
                false,
              )}
              {oomData?.x && (
                <span dangerouslySetInnerHTML={{ __html: oomData.x }} />
              )}
            </span>
          </div>
          <div>
            {t("results.value")}/{volumeUnit}:{" "}
            <span
              className={cx({
                [classes.mouseOverValue]: true,
                ["negative"]: plValues[numPL][metaName] < 0,
              })}
            >
              {currencyUnit}{" "}
              {formatValue(
                plValues[numPL][metaName],
                metaName,
                numPL,
                "per_unit",
                showValueByVolumeDecimals,
              )}
            </span>
          </div>
          <div>
            {t("results.percent_value")}:{" "}
            <span
              className={cx({
                [classes.mouseOverValue]: true,
              })}
            >
              {getPlPercentValue(numPL, metaName)}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

PnlTooltip.propTypes = {
  visible: PropTypes.bool.isRequired,
  mouseMoving: PropTypes.bool.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  metaName: PropTypes.string,
  numPL: PropTypes.number,
  plValues: PropTypes.object.isRequired,
  currencyUnit: PropTypes.string,
  volumeUnit: PropTypes.string,
  formatValue: PropTypes.func.isRequired,
  getPlPercentValue: PropTypes.func.isRequired,
  showValueByVolumeDecimals: PropTypes.bool.isRequired,
  tooltipRef: PropTypes.object.isRequired,
  oomData: PropTypes.object,
  t: PropTypes.func.isRequired,
};

export default PnlTooltip;
